import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";

import { loadLocations } from "../../store/actions/locationAction";
import { loadReglements } from "../../store/actions/reglementAction";
import { loadComptes } from "../../store/actions/compteAction";
import { saveQuittance } from "../../store/actions/quittanceAction";
import { saveEcriture } from "../../store/actions/ecritureAction";

import FormPrestationSupplementaire from "../../components/FormPrestationSupplementaire";

class PrestationsSupplementaires extends Component {
  componentDidMount() {
    this.props.loadLocations();
    this.props.loadReglements();
    this.props.loadComptes();
  }

  render() {
    const { locations, reglements, rubriques, comptes, journals } = this.props;

    return (
      <Spin
        spinning={!locations || !reglements || !comptes}
        size="large"
        tip="Chargement en cours..."
      >
        <FormPrestationSupplementaire
          locations={locations}
          reglements={reglements}
          rubriques={rubriques}
          comptes={comptes}
          journals={journals}
          saveQuittance={this.props.saveQuittance}
          saveEcriture={this.props.saveEcriture}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadLocations: () => dispatch(loadLocations()),
    loadReglements: () => dispatch(loadReglements()),
    loadComptes: () => dispatch(loadComptes()),
    saveQuittance: (jsonData) => dispatch(saveQuittance(jsonData)),
    saveEcriture: (ecriture) => dispatch(saveEcriture(ecriture)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    locations: state.locations.data,
    reglements: state.reglements.data,
    rubriques: state.rubriques.data,
    comptes: state.comptes.data,
    journals: state.journals.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrestationsSupplementaires);
